import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import { ImgixClient, BREAKPOINTS_WIDTHS } from '@belong/common';
import { twMerge } from 'tailwind-merge';
import cssImage from '../Image/Image.module.css.js';

function isExternal(to) {
  return to.includes('://');
}
const defaultClient = new ImgixClient({
  domain: 'belonghome.imgix.net'
});
// TODO: handle empty alt with aria values?
const Picture = /*#__PURE__*/React.forwardRef(function Picture({
  className,
  config = [],
  sources,
  client = defaultClient,
  lazy = true,
  ...rest
}, ref) {
  const breakpointsPerDeviceW = [{
    minW: ''
  }, {
    minW: `${BREAKPOINTS_WIDTHS.SM}px`
  }, {
    minW: `${BREAKPOINTS_WIDTHS.MD}px`
  }];
  const sourcesTags = sources.map((src, i) => {
    const breakpoint = breakpointsPerDeviceW[i];
    const configPerDevice = config[i] || {};
    const srcSet = !isExternal(src) ? client.buildSrcSet(src, {
      auto: 'format',
      ...configPerDevice
    }, {
      widthTolerance: 0.2
    }) : '';
    return jsx("source", {
      media: breakpoint && breakpoint.minW ? `(min-width: ${breakpoint.minW})` : '',
      srcSet: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
      "data-srcset": srcSet,
      "data-sizes": "auto"
    }, src + i);
  }).reverse();
  return jsxs("picture", {
    className: "contents",
    children: [sourcesTags, jsx("img", {
      className: twMerge('block w-full h-full', lazy && 'lazyload', cssImage.imageBase, className),
      ...rest,
      ref: ref
    })]
  });
});

export { Picture };
